<template>
  <div class="exam-uniform-score-exam-input"
       :class="{'is-pass': isScorePass, 'is-fail': isScoreFail}">
    <template v-if="cellValue">
      <div class="value">{{valueText}}</div>
      <div class="extra">
        <el-popover v-model="visible"
                    width="180px"
                    placement="top-end"
                    popper-class="exam-uniform-score-exam-input-popper">
          <div class="form-wrap">
            <div class="body">
              <el-form size="mini"
                       label-width="60px">
                <el-form-item label="科目成绩：">
                  <el-input-number v-model="form.score"
                                   controls-position="right"
                                   :min="0"
                                   :step="1"
                                   :precision="0"></el-input-number>
                </el-form-item>
                <el-form-item label="科目状态：">
                  <el-select v-model="form.scoreStatus"
                             clearable>
                    <template v-if="cellParam && cellParam.statusList">
                      <el-option v-for="(status, index) in cellParam.statusList"
                                 :key="'status-' + index"
                                 :label="status"
                                 :value="status"></el-option>
                    </template>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div class="footer">
              <el-button size="mini"
                         type="primary"
                         :loading="committing"
                         @click="handleApply">确定</el-button>
              <el-button size="mini"
                         type="default"
                         @click="handleClose">取消</el-button>
            </div>
          </div>
          <el-button slot="reference"
                     size="mini"
                     type="text"
                     icon="el-icon-edit"></el-button>
        </el-popover>
      </div>
    </template>
    <template v-else>
      <span class="not-join"></span>
    </template>
  </div>
</template>

<script>
import objectUtils from '../../../../../../../../../util/objectUtils'
export default {
  name: 'ExamUniformScoreExamValue',
  props: {
    rowData: {
      type: Object,
      required: true
    },
    cellValue: String,
    cellParam: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      visible: false,
      form: {
        score: undefined,
        scoreStatus: ''
      },
      committing: false
    }
  },
  computed: {
    subjectScore () {
      const cellParam = this.cellParam
      if (cellParam) {
        const subjectId = cellParam.subjectId
        if (subjectId) {
          return this.rowData[`score_${subjectId}`]
        }
      }
    },
    subjectScoreStatus () {
      const cellParam = this.cellParam
      if (cellParam) {
        const subjectId = cellParam.subjectId
        if (subjectId) {
          return this.rowData[`status_${subjectId}`]
        }
      }
    },
    valueText () {
      const score = this.subjectScore
      if (objectUtils.hasValue(score)) {
        const scoreStatus = this.subjectScoreStatus
        return `${scoreStatus}: ${score}`
      }
    },
    passScore () {
      const cellParam = this.cellParam
      if (cellParam) {
        const subjectId = cellParam.subjectId
        if (subjectId) {
          return this.rowData[`pass_${subjectId}`]
        }
      }
    },
    isScorePass () {
      const passScore = this.passScore
      if (passScore) {
        return passScore === '1'
      }
    },
    isScoreFail () {
      const passScore = this.passScore
      if (passScore) {
        return passScore !== '1'
      }
    }
  },
  methods: {
    handleApply () {
      if (objectUtils.hasValue(this.form.score)) {
        if (!this.form.scoreStatus) {
          this.$message.warning('请设置科目状态')
          return
        }
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/exam/uniform/score/modify',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          studentId: this.rowData.id
        }, this.cellParam, this.form))
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success('科目成绩修改成功')
              this.visible = false
              this.$nextTick(() => {
                this.$emit('reloadGridData')
              })
              break
            }
            default: {
              this.$message.error(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleClose () {
      this.visible = false
    }
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          const value = this.subjectScore
          if (objectUtils.hasValue(value)) {
            this.form.score = Number(value)
          } else {
            this.form.score = undefined
          }
          this.form.scoreStatus = this.subjectScoreStatus
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../../../../../../styles/color";
  .exam-uniform-score-exam-input {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.is-pass {
      & > .value {
        color: $set-success-color;
      }
    }
    &.is-fail {
      & > .value {
        color: $set-danger-color;
      }
    }
    & > .value {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &:empty {
        &:before {
          content: '\672a\5f55\5206';
          color: $set-empty-color;
        }
      }
    }
    & > .extra {
      margin-left: 5px;
    }
    & > .not-join {
      &:before {
        content: '\002f';
        color: $set-empty-color;
      }
    }
  }
  .exam-uniform-score-exam-input-popper {
    .form-wrap {
      & > .body {
        padding: 5px;
        .el-form {
          .el-form-item {
            &:last-child {
              margin-bottom: 0;
            }
            .el-form-item__label {
              font-size: 12px;
              padding-right: 0;
            }
            .el-form-item__content {
              .el-input-number {
                width: 100px;
                .el-input__inner {
                  text-align: left;
                  padding-left: 10px;
                  padding-right: 35px;
                }
              }
              .el-select {
                width: 100px;
              }
            }
          }
        }
      }
      & > .footer {
        margin-top: 10px;
        text-align: center;
        .el-button {
          padding: 5px 12px;
        }
      }
    }
  }
</style>
